<template>
  <div class="i-table clearfix">
    <Spin size="large" fix v-if="tableSpinShow">
      <slot>
        <div>
          <Icon type="ios-loading" size="40" class="demo-spin-icon-load"></Icon>
          <div>数据加载中</div>
        </div>
      </slot>
    </Spin>
    <Row class="i-table-top-btns">
      <i-button
        v-for="btn of actions.def"
        :type="btn.type"
        @click="btn.handler"
        :icon="btn.icon"
        >{{ btn.name }}
      </i-button>
    </Row>
    <i-table
      ref="elTable"
      :loading="loading"
      :size="tableSize"
      :data="tableData"
      :show-header="!prop.notShowHeader ? true : false"
      :height="tableHeight"
      :columns="prop.columns"
      :row-class-name="rowClassName"
      @on-sort-change="handleSortChange"
      @on-selection-change="getSelectRow"
      @on-selection-all="getAllRow"
      @on-select-all-cancel="unSelectAll"
      @on-current-change="handleCurrentRowChange"
      @on-row-click="handleRowClick"
      highlight-row
      stripe
    >
    </i-table>
    <Page
      @on-page-size-change="handleSizeChange"
      @on-change="handleCurrentPageChange"
      :page-size-opts="pagination.pageSizes"
      :page-size="pagination.pageSize"
      :total="pagination.total"
      :current="pagination.currentPage"
      :show-total="showTotal"
      :show-sizer="showSizer"
      v-show="pageShow"
    >
    </Page>
  </div>
</template>
<script>
import DgPorTableMixins from "./DgPorTableMixins";

require("lodash"); //引用函数库lodash来做深copy
export default {
  name: "DgPorTable",
  mixins: [DgPorTableMixins],
  props: ["prop"],
  data() {
    return {
      pageShow: true,
      self: this,
      loading: false,
      tableSpinShow: false,
      tableSize: "default",
      tableHeight: null,
      tableData: [],
      actions: {},
      pagination: {
        pageSize: this.prop.pageInfo ? this.prop.pageInfo.pageSize : 10,
        total: 0,
        pageSizes: this.prop.pageInfo
          ? this.prop.pageInfo.pageSizes
          : [10, 20, 50, 100],
        currentPage: 1,
        order: null,
        sort: null,
      },
      showTotal: true,
      showSizer: true,
      resultSize: 0,
    };
  },
  methods: {
    initWindowEvent() {
      window.addEventListener("resize", () => {
        this.calculateTableHeight();
      });
    },
    calculateTableHeight() {
      let height = jq(".body").height() - jq(".i-table-top-btns").height() - 60;
      if (jq(".ivu-page").length > 0) {
        height -= jq(".ivu-page").height();
      }
      if (jq("[class$='-search']").length > 0) {
        let searchNum = jq("[class$='-search']").length;
        height -= jq("[class$='-search']").height();
      }
      // if(jq(".echarts-item").length>0){
      //     height-=jq(".echarts-item").height();
      // }
      if (jq(".item-list").length > 0) {
        height -= jq(".item-list").height();
      }
      if (jq(".tabs-box").length > 0) {
        height = height - 30;
      }
      this.tableHeight = height;
      console.log(height);
    },
    rowClassName(row, index) {
      if (this.prop.highlightValue) {
        let key = this.prop.highlightColumn;
        if (row[key] == this.prop.highlightValue) {
          return "ws-highlight-row";
        } else {
          return "";
        }
      }
    },
  },
  mounted() {
    // this.initWindowEvent();
    //  this.calculateTableHeight()
  },
};
</script>


// WEBPACK FOOTER //
// src/components/dynamicTable/DgPorTable.vue